import React from "react";
import "./navbar.css";
import logoSvg from "../../assets/clubsta1.svg";
import { Link, useLocation } from "react-router-dom";
import ClaimButton from "../ClaimButton";
import CitySelector from "../CitySelector/CitySelector";

export default function NavBar({ selectedCity, setSelectedCity }) {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Check if we're on the homepage
  const isHomePage = location.pathname === '/';

  return (
    <div className="navbar-wrapper">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo-link">
          <img src={logoSvg} alt="Logo" className="navbar-logo" />
        </Link>
        
        <div className="navbar-city-selector">
          <CitySelector selectedCity={selectedCity} setSelectedCity={setSelectedCity} />
        </div>
        
        <div className="navbar-hamburger" onClick={toggleMenu}>
          <div className="hamburger-icon">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        <div className={`navbar-actions ${isMenuOpen ? "open" : ""}`}>
          {/* Only show Home link if NOT on homepage */}
          {!isHomePage && <Link to="/" className="navbar-link">Home</Link>}
          <Link to="/aboutus" className="navbar-link">About Us</Link>
        </div>
      </div>
    </div>
  );
}